import { useState, useEffect } from 'react';
import { Moon, Sun } from '@phosphor-icons/react';

import styles from './ThemeToggle.module.css';

function getInitialTheme(): boolean {
    const stored = localStorage.getItem('theme');
    if (stored) return stored === 'dark';
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
}

export function ThemeToggle() {
    const [isDark, setIsDark] = useState(getInitialTheme);

    // Apply theme on mount and sync with DOM
    useEffect(() => {
        document.documentElement.classList.toggle('dark', isDark);
    }, [isDark]);

    const handleToggle = () => {
        const next = !isDark;
        setIsDark(next);
        localStorage.setItem('theme', next ? 'dark' : 'light');
    };

    return (
        <button
            type="button"
            onClick={handleToggle}
            className={`${styles.toggle} ${isDark ? styles.dark : ''}`}
            aria-label={isDark ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
        >
            <span className={styles.iconWrapper}>
                <Sun size={14} weight="bold" className={styles.sunIcon} />
            </span>
            <span className={styles.iconWrapper}>
                <Moon size={14} weight="bold" className={styles.moonIcon} />
            </span>
            <span className={styles.slider} />
        </button>
    );
}
